import * as tslib_1 from "tslib";
import * as React from 'react';
import { Component } from 'react';
import Locky from 'react-locky';
import { styleSinglentone } from 'react-style-singleton';
import { getGapWidth, getOffsetTop } from './utils';
var Style = styleSinglentone();
var getStyles = function (gap, allowRelative, gapMode, important) {
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  return "\n  body {\n    overflow: hidden " + important + ";\n    " + [allowRelative && "position: relative " + important + ";", gapMode == 'margin' && "margin-right: " + gap + "px " + important + ";", gapMode == 'padding' && "padding-right: " + gap + "px " + important + ";"].filter(Boolean).join('') + "\n  }\n  \n  .react-scroll-locky-extender {\n    position: absolute;    \n    left: 0;    \n    right: -" + gap + "px;\n  }\n  \n  .react-scroll-locky-edge-right {\n    right: " + gap + "px;\n  }\n  \n  .react-scroll-locky-extender .react-scroll-locky-extender,\n  .react-scroll-locky-edge-right. .react-scroll-locky-edge-right {\n    right: 0;\n  }\n  \n  .react-scroll-locky {\n    -webkit-overflow-scrolling: touch;\n  }\n";
};
var HideBodyScroll = function (_super) {
  tslib_1.__extends(HideBodyScroll, _super);
  function HideBodyScroll() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      gap: getGapWidth(_this.props.gapMode)
    };
    return _this;
  }
  HideBodyScroll.prototype.componentDidMount = function () {
    var gap = getGapWidth(this.props.gapMode);
    if (gap !== this.state.gap) {
      this.setState({
        gap: gap
      });
    }
  };
  HideBodyScroll.prototype.render = function () {
    var _a = this.props,
      noRelative = _a.noRelative,
      noImportant = _a.noImportant,
      gapMode = _a.gapMode;
    var gap = this.state.gap;
    return gap ? React.createElement(Style, {
      styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : '')
    }) : null;
  };
  return HideBodyScroll;
}(React.Component);
export { HideBodyScroll };
var ScrollLocky = function (_super) {
  tslib_1.__extends(ScrollLocky, _super);
  function ScrollLocky() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ScrollLocky.prototype.componentDidMount = function () {
    this.check();
  };
  ScrollLocky.prototype.componentDidUpdate = function () {
    this.check();
  };
  ScrollLocky.prototype.check = function () {
    if (process.env.NODE_ENV !== 'production') {
      if (!this.props.noRelative && getOffsetTop()) {
        console.error('ScrollLocky expect BODY to have zero margins when noRelative is not set');
      }
    }
  };
  ScrollLocky.prototype.render = function () {
    var _a = this.props,
      _b = _a.enabled,
      enabled = _b === void 0 ? true : _b,
      _c = _a.hideBodyScroll,
      hideBodyScroll = _c === void 0 ? true : _c,
      children = _a.children,
      noRelative = _a.noRelative,
      _d = _a.gapMode,
      gapMode = _d === void 0 ? 'margin' : _d,
      noImportant = _a.noImportant,
      className = _a.className,
      headless = _a.headless,
      onEscape = _a.onEscape,
      _e = _a.isolation,
      isolation = _e === void 0 ? true : _e;
    var lockProps = isolation ? {} : {
      noDefault: true,
      events: {
        scroll: true,
        wheel: true,
        touchmove: true,
        touchstart: 'report-only',
        click: "report-only"
      }
    };
    return React.createElement(React.Fragment, null, enabled && hideBodyScroll && React.createElement(HideBodyScroll, {
      noImportant: noImportant,
      noRelative: noRelative,
      gapMode: gapMode
    }), React.createElement(Locky, tslib_1.__assign({
      enabled: !!enabled,
      className: ("react-scroll-locky " + (className || '')).trim(),
      leaded: true,
      group: "react-scroll-locky",
      headless: headless,
      onEscape: onEscape
    }, lockProps), children));
  };
  return ScrollLocky;
}(Component);
export { ScrollLocky };
export var ScrollLockyPane = function (_a) {
  var children = _a.children,
    className = _a.className,
    style = _a.style;
  return React.createElement("div", {
    className: "react-scroll-locky-extender " + (className || ''),
    style: style
  }, children);
};